module.exports = __webpack_public_path__ + "img/crank.cbb4a87a.jpg";